export default "__VITE_ASSET__WPhziMWm__"